"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadMessages = void 0;
const web_i18n_1 = require("@snapchat/web-i18n");
async function loadMessages(locale) {
    // eslint-disable-next-line sonarjs/max-switch-cases
    switch (locale) {
        case web_i18n_1.Locale.ar:
        case web_i18n_1.Locale.arAR:
            return (await Promise.resolve().then(() => __importStar(require("../lang/ar.json")))).default;
        case web_i18n_1.Locale.bnBD:
            return (await Promise.resolve().then(() => __importStar(require("../lang/bn-BD.json")))).default;
        case web_i18n_1.Locale.bnIN:
            return (await Promise.resolve().then(() => __importStar(require("../lang/bn-IN.json")))).default;
        case web_i18n_1.Locale.daDK:
            return (await Promise.resolve().then(() => __importStar(require("../lang/da-DK.json")))).default;
        case web_i18n_1.Locale.deDE:
            return (await Promise.resolve().then(() => __importStar(require("../lang/de-DE.json")))).default;
        case web_i18n_1.Locale.enGB:
            return (await Promise.resolve().then(() => __importStar(require("../lang/en-GB.json")))).default;
        case web_i18n_1.Locale.elGR:
            return (await Promise.resolve().then(() => __importStar(require("../lang/el-GR.json")))).default;
        case web_i18n_1.Locale.es:
        case web_i18n_1.Locale.esES:
            return (await Promise.resolve().then(() => __importStar(require("../lang/es.json")))).default;
        case web_i18n_1.Locale.esAR:
            return (await Promise.resolve().then(() => __importStar(require("../lang/es-AR.json")))).default;
        case web_i18n_1.Locale.esMX:
            return (await Promise.resolve().then(() => __importStar(require("../lang/es-MX.json")))).default;
        case web_i18n_1.Locale.fiFI:
            return (await Promise.resolve().then(() => __importStar(require("../lang/fi-FI.json")))).default;
        case web_i18n_1.Locale.filPH:
            return (await Promise.resolve().then(() => __importStar(require("../lang/fil-PH.json")))).default;
        case web_i18n_1.Locale.frFR:
            return (await Promise.resolve().then(() => __importStar(require("../lang/fr-FR.json")))).default;
        case web_i18n_1.Locale.guIN:
            return (await Promise.resolve().then(() => __importStar(require("../lang/gu-IN.json")))).default;
        case web_i18n_1.Locale.hiIN:
            return (await Promise.resolve().then(() => __importStar(require("../lang/hi-IN.json")))).default;
        case web_i18n_1.Locale.idID:
            return (await Promise.resolve().then(() => __importStar(require("../lang/id-ID.json")))).default;
        case web_i18n_1.Locale.itIT:
            return (await Promise.resolve().then(() => __importStar(require("../lang/it-IT.json")))).default;
        case web_i18n_1.Locale.jaJP:
            return (await Promise.resolve().then(() => __importStar(require("../lang/ja-JP.json")))).default;
        case web_i18n_1.Locale.knIN:
            return (await Promise.resolve().then(() => __importStar(require("../lang/kn-IN.json")))).default;
        case web_i18n_1.Locale.koKR:
            return (await Promise.resolve().then(() => __importStar(require("../lang/ko-KR.json")))).default;
        case web_i18n_1.Locale.mlIN:
            return (await Promise.resolve().then(() => __importStar(require("../lang/ml-IN.json")))).default;
        case web_i18n_1.Locale.mrIN:
            return (await Promise.resolve().then(() => __importStar(require("../lang/mr-IN.json")))).default;
        case web_i18n_1.Locale.msMY:
            return (await Promise.resolve().then(() => __importStar(require("../lang/ms-MY.json")))).default;
        case web_i18n_1.Locale.nbNO:
            return (await Promise.resolve().then(() => __importStar(require("../lang/nb-NO.json")))).default;
        case web_i18n_1.Locale.nlNL:
            return (await Promise.resolve().then(() => __importStar(require("../lang/nl-NL.json")))).default;
        case web_i18n_1.Locale.pa:
            return (await Promise.resolve().then(() => __importStar(require("../lang/pa.json")))).default;
        case web_i18n_1.Locale.plPL:
            return (await Promise.resolve().then(() => __importStar(require("../lang/pl-PL.json")))).default;
        case web_i18n_1.Locale.ptBR:
            return (await Promise.resolve().then(() => __importStar(require("../lang/pt-BR.json")))).default;
        case web_i18n_1.Locale.ptPT:
            return (await Promise.resolve().then(() => __importStar(require("../lang/pt-PT.json")))).default;
        case web_i18n_1.Locale.roRO:
            return (await Promise.resolve().then(() => __importStar(require("../lang/ro-RO.json")))).default;
        case web_i18n_1.Locale.ruRU:
            return (await Promise.resolve().then(() => __importStar(require("../lang/ru-RU.json")))).default;
        case web_i18n_1.Locale.svSE:
            return (await Promise.resolve().then(() => __importStar(require("../lang/sv-SE.json")))).default;
        case web_i18n_1.Locale.taIN:
            return (await Promise.resolve().then(() => __importStar(require("../lang/ta-IN.json")))).default;
        case web_i18n_1.Locale.teIN:
            return (await Promise.resolve().then(() => __importStar(require("../lang/te-IN.json")))).default;
        case web_i18n_1.Locale.thTH:
            return (await Promise.resolve().then(() => __importStar(require("../lang/th-TH.json")))).default;
        case web_i18n_1.Locale.trTR:
            return (await Promise.resolve().then(() => __importStar(require("../lang/tr-TR.json")))).default;
        case web_i18n_1.Locale.urPK:
            return (await Promise.resolve().then(() => __importStar(require("../lang/ur-PK.json")))).default;
        case web_i18n_1.Locale.viVN:
            return (await Promise.resolve().then(() => __importStar(require("../lang/vi-VN.json")))).default;
        case web_i18n_1.Locale.zhHans:
            return (await Promise.resolve().then(() => __importStar(require("../lang/zh-Hans.json")))).default;
        case web_i18n_1.Locale.zhHant:
            return (await Promise.resolve().then(() => __importStar(require("../lang/zh-Hant.json")))).default;
        case web_i18n_1.Locale.enPLOC:
        case web_i18n_1.Locale.enUS:
        default:
            return (await Promise.resolve().then(() => __importStar(require("../lang/en-US.json")))).default;
    }
}
exports.loadMessages = loadMessages;
//# sourceMappingURL=messageLoader.js.map